import { AuthState } from '@/types/state'
import * as actionTypes from '@/store/action-types'
import * as mutationTypes from '@/store/mutation-types'

import { UserCredentialsPayload } from '@/types/payload'
import { CurrentUser } from '@/model/CurrentUser'
import * as getterTypes from '@/store/getter-types'
import axios from '@/plugins/axios'
import InvalidCredentialsError from '@/model/error/InvalidCredentialsError'
import {AxiosResponse} from "axios";
import {TOKEN_FIELD} from "@/constants";

const state: AuthState = {
  currentUser: undefined,
  token: undefined,
  isInvalidToken: false,
}

const getters = {
  [getterTypes.USER_LOGGED_IN] (state: AuthState): CurrentUser | undefined {
    return state.currentUser
  },

  [getterTypes.AUTH_TOKEN] (state: AuthState): string | undefined {
    return state.token
  },
  [getterTypes.IS_INVALID_TOKEN] (state: AuthState): boolean {
    return state.isInvalidToken
  }

}

const mutations = {
  [mutationTypes.AUTH_SET_CURRENT_USER_MUTATION] (state: AuthState, payload: CurrentUser): void {
    state.currentUser = payload
  },

  [mutationTypes.AUTH_SET_TOKEN] (state: AuthState, payload: string): void {
    state.token = payload
    localStorage.setItem(TOKEN_FIELD, payload)
  },
  [mutationTypes.SET_INVALID_TOKEN_MUTATION] (state: AuthState, payload: boolean): void {
    state.isInvalidToken = payload
  }

}

const actions = {
  [actionTypes.SET_INVALID_TOKEN]({commit}: { commit: Function }, payload: boolean): void {
    commit(mutationTypes.SET_INVALID_TOKEN_MUTATION, payload)
  },

  async [actionTypes.AUTH_LOG_USER_IN] ({ commit }: { commit: Function }, payload: UserCredentialsPayload): Promise<CurrentUser> {

    let data = {
      'username': payload.username,
      'password': payload.password
    }

    try {
      let res = await axios.post('/api/login',data)

      const token = res.data.token;

      let headers = {
        'Authorization': 'Bearer ' + token
      }

      let res_user_account:any = await axios.get('/api/account',{ headers:headers})

      if (!res_user_account.data.isStaff) {
        // noinspection ExceptionCaughtLocallyJS
        throw new InvalidCredentialsError()
      }

      // SET TO LOCALSTORAGE
      localStorage.setItem('token', token);

      const user = CurrentUser.createFromUserInformationResponse({
        id: res_user_account.data.id,
        givenName: res_user_account.data.firstName,
        familyName: res_user_account.data.familyName,
        isBoarder: res_user_account.data.isBoarder,
        staffRoleList:res_user_account.data.staffRoleList,
        boarderList: res_user_account.data.boarderList,
        isStaff: res_user_account.data.isStaff,
        tenant: res_user_account.data.tenant,
        phoneNumbers: res_user_account.data.phoneNumbers,
        loginName: res_user_account.data.loginName
      })

      commit(mutationTypes.AUTH_SET_CURRENT_USER_MUTATION, user)

      return user
    } catch (e) {
      throw new InvalidCredentialsError()
    }
  },

  async [actionTypes.AUTH_LOG_USER_OUT] ({ commit }: { commit: Function }): Promise<void> {

    commit(mutationTypes.AUTH_SET_CURRENT_USER_MUTATION, undefined)
    localStorage.setItem('token','');
  },

  async [actionTypes.AUTH_LOG_USER_IN_WITH_TOKEN] ({ commit }: { commit: Function }, payload: string): Promise<CurrentUser> {

    let headers = {
      'Authorization': 'Bearer ' + payload
    }
    try {
      let res_user_account: AxiosResponse = await axios.get('/api/account', { headers:headers})

      const user = CurrentUser.createFromUserInformationResponse({
        id: res_user_account.data.id,
        givenName: res_user_account.data.firstName,
        familyName: res_user_account.data.familyName,
        isBoarder: res_user_account.data.isBoarder,
        staffRoleList:res_user_account.data.staffRoleList,
        boarderList: res_user_account.data.boarderList,
        isStaff: res_user_account.data.isStaff,
        tenant: res_user_account.data.tenant,
        phoneNumbers: res_user_account.data.phoneNumbers,
        loginName: res_user_account.data.loginName
      })

      commit(mutationTypes.AUTH_SET_CURRENT_USER_MUTATION, user)

      return user
    } catch (e) {
      throw new InvalidCredentialsError()
    }
  },
  async [actionTypes.AUTH_INIT_MODULE] ({ commit }: { commit: Function }): Promise<void> {
    const authToken = localStorage.getItem(TOKEN_FIELD)

    if (authToken) {
      commit(mutationTypes.AUTH_SET_TOKEN, authToken)
    }
  },

}

const authModule = {
  state,
  getters,
  mutations,
  actions
}

export default authModule
